<template>
  <list listTitle="Migração de anúncios" :listLogo="moduleDefinition.logo" filterTitle="Filtros" :loading="loading" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'asc' }" :total="mercadoLivreAnnouncementsMigrationTotal" @change="onChange">
    <template slot="filters">
      <form-group label="Conta">
        <select v-model="options.account" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="account in mercadoLivreAccounts" :value="account.identifier">{{ `${account.name} (${account.nickname})` }}</option>
        </select>
      </form-group>

      <div class="l-col-12@md" v-if="options.account">
        <div class="l-row">
          <form-group label="Código do anúncio">
            <input class="form-input" v-model="options.code">
          </form-group>

          <form-group label="Título do anúncio">
            <input class="form-input" v-model="options.title">
          </form-group>

          <form-group label="Status de Migração">
            <select v-model="options.status" class="form-select">
              <option :value=null>{{ $t('choose.label') }}</option>
              <option v-for="status in migration.status" :value="status">{{ $t(`mercadoLivre.migration.${status}.label`) }}</option>
            </select>
          </form-group>

          <form-group label="Status do Anúncio">
            <select v-model="options.statusAnnouncement" class="form-select">
              <option :value=null>{{ $t('choose.label') }}</option>
              <option v-for="status in statusesAnnouncement" :value="status">{{ $t(`${status}.label`) }}</option>
            </select>
          </form-group>
        </div>
      </div>
    </template>

    <div class="l-col-12@md" v-if="announcementsMigration.length && options.account">
      <announcement-migration-card v-for="announcementMigration in announcementsMigration" :key="announcementsMigration" :modules="modules" :announcement="announcementMigration" :account="options.account"/>
    </div>
    <div class="l-col-12@md u-textCenter" v-else>
      <panel>Nenhum anúncio encontrado.</panel>
    </div>
  </list>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge } from 'lodash'
  import List from '@/components/shared/list/Paginator'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import AnnouncementMigrationCard from '@/components/marketplace/mercadoLivre/AnnouncementMigrationCard'

  export default {
    inject: ['expeditersDI'],
    data: () => ({
      sortFields: [
        'title'
      ],
      migration: {
        status: [
          'pending',
          'partial',
          'done'
        ]
      },
      statusesAnnouncement: [],
      loading: true,
      options: {
        account: null,
        status: null,
        title: null,
        code: null,
        statusAnnouncement: null
      },
      modules: []
    }),
    async created () {
      await this.clearAnnouncementsMigration()
    },
    mounted () {
      this.fetchAccounts({})
        .then(() => {
          if (this.mercadoLivreAccounts.length === 1) {
            this.options.account = this.mercadoLivreAccounts[0].identifier
          }

          for (let i in this.expeditersDI) {
            const type = this.expeditersDI[i].type

            for (let j in this.expeditersDI[i].identifiers) {
              const identifier = this.expeditersDI[i].identifiers[j]

              if (!this.definitionModulesInstalled.find(module => module.type === type && module.identifier === identifier)) {
                continue
              }

              this.modules.push({
                type: type,
                identifier: identifier
              })
            }
          }

          this.loading = false
        })
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts'
      ]),
      ...mapActions('mercadoLivreAnnouncementsMigration', [
        'fetchAnnouncementsMigration',
        'fetchMoreAnnouncementsMigration',
        'clearAnnouncementsMigration'
      ]),
      onChange (options) {
        this.clearAnnouncementsMigration()

        if (this.options.account === null) {
          return false
        }

        this.loading = true

        if (options === undefined) {
          options = this.$children[0].options
        }

        merge(this.options, options)

        this.fetchAnnouncementsMigration({
          options: this.options,
          account: this.options.account
        })
          .finally(() => {
            this.loading = false
          })
      }
    },
    computed: {
      ...mapFields({
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts',
        announcementsMigration: 'mercadoLivreAnnouncementsMigration.announcementsMigration',
        mercadoLivreAnnouncementsMigrationTotal: 'mercadoLivreAnnouncementsMigration.total'
      }),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType',
        'definitionModulesInstalled'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'mercadoLivre')
      },
      announcements () {
        if (this.announcementsMigration) {
          return this.announcementsMigration
        }

        return []
      }
    },
    watch: {
      'options.account' (value) {
        api.mercadoLivre.getAnnouncementMigrationStatuses(value)
          .then(statuses => { this.statusesAnnouncement = statuses })
          .catch(() => notifier.error('Erro ao buscar status dos anúncios de migração.', 'Erro'))
      }
    },
    components: {
      List,
      Panel,
      FormGroup,
      AnnouncementMigrationCard
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Migration.vue?94fec8cc